import { InjectionToken } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IAppConfig } from "@models/core/setting";

export const APP_CONFIG = new InjectionToken<BehaviorSubject<IAppConfig>>(
  "APP_CONFIG",
  {
    providedIn: "root",
    factory: () => new BehaviorSubject<IAppConfig>(null),
  },
);
